import React from 'react';
import { Navigate } from 'react-router-dom';
import { getToken } from 'src/helpers/TokenHelper';

const GuestRoute = (children) => {
  if (getToken()) {
    return <Navigate to="/" />;
  }

  return children.children;
};

export default GuestRoute;
